// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputCheckbox from '@/components/input/modules/checkbox'

// vuex
import { mapState } from 'vuex'

// utils
import maEventbus from '@/components/eventbus'

export default {
  name: 'AdminView',
  data: function () {
    return {
      table: null,
      currentPage: 1,
      totalPages: 0,
      filterWarrantyId: null,
      filterSubwarrantyId: null
    }
  },
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputCheckbox
  },
  computed: {
    ...mapState({
      stateUserRole: state => state.user.role || null
    }),
    hasData: function () {
      return this.table && this.table.length > 0
    }
  },
  methods: {
    handleFiltersChange: function (filters) {
      this.filterWarrantyId = filters.warranty
      this.filterSubwarrantyId = filters.subwarranty
      this.currentPage = 1
      this.handleSearch()
    },
    handlePageUpdate: function (page) {
      this.currentPage = page
      this.handleSearch()
    },
    handlePageSet: function (page) {
      this.currentPage = page
    },
    handleCancel: function () {
      this.resetEditValues()
      this.$refs.adminGagEditModal.showModal = false
    }
  },
  mounted: function () {
    this.handleSearch()
    maEventbus.$on('onAdminGAGImportTemplateEnd', this.handleSearch)
  },
  destroyed: function () {
    maEventbus.$off('onAdminGAGImportTemplateEnd')
  }
}
